import { InstituteTypeListTable } from '../components/InstituteTypeListTable';

export function InstituteTypeListPage() {
  return <InstituteTypeListTable />;
}
